import { INFLUENCER_SIGNUP_CATEGORIES } from '../../../constants/influencerOptions';
import { countWords, PROFILE_BIO_MIN_WORDS } from '../../settings/profileFormHelpers';
import {
  BRAND_REVENUE_OPTIONS,
} from '../../../constants/brandOptions';
import { validateFollowSuggestions } from '../shared/followSuggestionGroups';

export const BRAND_QUICK_STEP_IDS = {
  NAME: 'name',
  BRAND_PROFILE: 'brandProfile',
  BRAND_DESCRIPTION: 'brandDescription',
  CREATOR_CATEGORIES: 'creatorCategories',
  SOCIAL_HANDLES: 'socialHandles',
  BUDGET_RANGE: 'budgetRange',
  FOLLOW: 'follow',
};

export function getBrandQuickSteps() {
  return [
    {
      id: BRAND_QUICK_STEP_IDS.NAME,
      question: 'What should creators call you?',
      helperText: 'This name will appear on your profile and in messages with creators.',
      inputType: 'aboutYou',
      required: true,
      validate: (formData) => {
        if (!formData.fullName?.trim()) return 'Please enter your full name.';
        return null;
      },
    },
    {
      id: BRAND_QUICK_STEP_IDS.BRAND_PROFILE,
      question: 'How should creators see your brand?',
      helperText: 'Add your brand name and logo so creators recognize you.',
      inputType: 'brandProfile',
      required: true,
      validate: (formData) => {
        if (!formData.companyName?.trim()) return 'Please enter your brand name.';
        if (!formData.brandLogoUrl?.trim()) return 'Please upload your logo.';
        return null;
      },
    },
    {
      id: BRAND_QUICK_STEP_IDS.BRAND_DESCRIPTION,
      question: 'Tell creators about your brand',
      helperText: 'Add at least 5 words so creators know what you sell.',
      inputType: 'brandDescription',
      required: true,
      validate: (formData, options = {}) => {
        if (!formData.companyDescription?.trim()) return 'Please add a brand description.';
        if (
          !options.skipWordMinimum
          && countWords(formData.companyDescription) < PROFILE_BIO_MIN_WORDS
        ) {
          return 'Use at least 5 words.';
        }
        return null;
      },
    },
    {
      id: BRAND_QUICK_STEP_IDS.CREATOR_CATEGORIES,
      question: 'What type of creators are you looking for?',
      helperText: 'Pick a few categories so Millet can start finding the right voices.',
      inputType: 'multiSelect',
      field: 'influencerCategories',
      options: INFLUENCER_SIGNUP_CATEGORIES,
      maxSelect: 5,
      required: true,
      validate: (formData) => (
        formData.influencerCategories?.length === 0 ? 'Select at least one creator category.' : null
      ),
    },
    {
      id: BRAND_QUICK_STEP_IDS.SOCIAL_HANDLES,
      question: 'Where else can creators find you?',
      helperText: 'Optional. Add your TikTok, Instagram, or Whatnot handles if you sell or promote there.',
      inputType: 'socialHandles',
      required: false,
    },
    {
      id: BRAND_QUICK_STEP_IDS.BUDGET_RANGE,
      question: 'What stage are you in?',
      helperText: 'Optional. A rough signal helps us keep recommendations realistic.',
      inputType: 'multiSelect',
      field: 'annualRevenue',
      options: BRAND_REVENUE_OPTIONS,
      maxSelect: 1,
      required: false,
    },
    {
      id: BRAND_QUICK_STEP_IDS.FOLLOW,
      question: 'Save creators to start',
      helperText: 'Select 1 or more, or skip this step.',
      inputType: 'followSuggestions',
      actionLabel: 'Save',
      required: false,
      validate: validateFollowSuggestions,
    },
  ];
}
